import { Order } from '../requests/caipirinha-api/interfaces/order.interface';

export const isContainsServices = (order: Order) => {
  const isOrderServices =
    order.details.services && order.details.services.length > 0;
  const isProductService =
    order.details.products &&
    order.details.products.filter((item) => item.services).length > 0;

  return isOrderServices || isProductService;
};
